define(['jquery'], function($) {
  "use strict";

  /* reliability-sdk v1.0.3 2015-09-24 - Copyright 2014, SMART Technologies Inc */
  var ReliabilitySDK = function () {
    var _sendBatchExecutionTimer = null;
    var _eventBatch = [];

    var _config = {
      sendBatchDelay: 10000,
      baseUrl: "https://smart-metricsproxy-dev.appspot.com",
      environment: "dev"
    };

    function updateConfig(args) {
      _config.sendBatchDelay = args.sendBatchDelay || _config.sendBatchDelay;
      _config.baseUrl = args.baseUrl || _config.baseUrl;
      _config.fullUrl = args.fullUrl;
      _config.environment = args.environment || _config.environment;
    }

    function createEvent(args) {
      var valueType = typeof (args.value);
      if (valueType !== "number") {
        throw "Reliability SDK - createEvent: 'value' property is expected to be of type 'number', but was '" + valueType + "'";
      }

      return {
        serviceId: args.serviceId || "UNKNOWN_SERVICE_ID",
        category: args.category || null,
        componentId: args.componentId || "UNKNOWN_COMPONENT_ID",
        metricLabel: args.metric || "UNKNOWN_METRIC",
        value: [ Math.round(args.value) ], // event proxy expects a long
        metadata: args.metadata || null,
        type: args.type || ReliabilitySDK.enums.SMART_METRIC_TYPE.NOT_SPECIFIED
      };
    }

    function findIndexOfMatchingEvent(args) {
      var i, len = _eventBatch.length;

      // TODO: Evaluate if the assumption can be made that it is more likely
      //       to find the existing event at the end. If so, revert loop to start wiht
      //       the last index.
      for (i = 0; i < len; i++) {
        var ev = _eventBatch[i];
        if (ev.serviceId === args.serviceId &&
          ev.category === args.category &&
          ev.componentId === args.componentId &&
          ev.metricLabel === args.metric &&
          ev.type === args.type &&
          ev.metadata === args.metadata) {

          return i;
        }
      }
      return -1;
    }

    function addOrUpdateEventForBatchSubmission(args) {
      var existingEventIndex = findIndexOfMatchingEvent(args);

      if (existingEventIndex > -1) {
        _eventBatch[existingEventIndex].value.push(args.value);
      } else {
        _eventBatch.push(createEvent(args));
      }

      if (_sendBatchExecutionTimer === null) {
        _sendBatchExecutionTimer = new ReliabilitySDK.Timer({func: sendEvents, delay: _config.sendBatchDelay});
      }
    }

    function sendEvents(args) {
      if (_sendBatchExecutionTimer !== null) {
        _sendBatchExecutionTimer.dispose();
      }

      _sendBatchExecutionTimer = null;

      var eventsToBeSent = _eventBatch.splice(0, _eventBatch.length);
      if (eventsToBeSent.length === 0) {
        return;
      }
      
      var url = _config.fullUrl ? _config.fullUrl : _config.baseUrl + "/v2/event/" + _config.environment

      var reqSettings = {
        async: true,
        type: "POST",
        url: url,
        data: JSON.stringify(eventsToBeSent),
        contentType: "application/json"
      };

      if (args) {
        reqSettings.async = (typeof(args.async) !== "boolean" || args.async);
      }

      $.ajax(reqSettings);
    }

    function timeExecution(func, eventArgs) {
      if (typeof (func) !== "function") {
        throw "Reliability SDK - timeExecution: 'func' must be provided and of type 'function'";
      }
      if (typeof(eventArgs) !== "object") {
        throw "Reliability SDK - timeExecution: 'eventArgs' must be provided and of type 'object'";
      }

      var startTime = new Date();
      try {
        func();
      } finally {
        var duration = new Date() - startTime;
        if (!eventArgs.threshold || eventArgs.threshold < duration) {
          addOrUpdateEventForBatchSubmission(
            $.extend({}, eventArgs, { value: duration, type: ReliabilitySDK.enums.SMART_METRIC_TYPE.TIMER })
          );
        }
      }
    }

    function startTrackExecutionTimer(args) {
      var startTime = new Date();
      var completed = false;
      var duration = 0;

      return {
        done: function (additionalMetadata) {
          if (completed) {
            return duration;
          }
          completed = true;

          duration = new Date() - startTime;

          if (!args.threshold || args.threshold < duration) {
            addOrUpdateEventForBatchSubmission(
              $.extend(true, {}, args, { value: duration, type: ReliabilitySDK.enums.SMART_METRIC_TYPE.TIMER, metadata: additionalMetadata })
            );
          }

          return duration;
        }
      };
    }

    return {
      config: {
        /**
         * Update the current configuration of the SDK
         * @param {object} args
         *   @param {number} args.sendBatchDelay: time in ms for how long events can be added to a batch before it is sent out
         *   @param {string} args.baseUrl: the base URL for the proxy service
         *   @param {string} args.environment: the environment for which the events are recorded
         */
        update: updateConfig
      },
      event: {
        /**
         * Record an event with the Reliability API
         * @param {object} args
         *   @param {number} args.value: <int> value to be recorded
         *   @param {string} args.serviceId: (opt) Identifier of the service for which the event is recorded
         *   @param {string} args.category: (opt)  category of this metric, see SMART.reliability.enums.SMART_METRIC_CATEGORIES, default is NULL
         *   @param {string} args.componentId: (opt) identifier for the component of this service, default is "UNKNOWN_COMPONENT_ID"
         *   @param {string} args.metric: (opt) label of the metric, default is "UNKNOWN_METRIC"
         *   @param {object} args.metadata: (opt) map of metadata for this event, default is NULL
         *   @param {string} args.type: (opt) type of the metric, see SMART.reliability.enums.SMART_METRIC_TYPE, default is SMART_METRIC_TYPE.NOT_SPECIFIED
         */
        send: addOrUpdateEventForBatchSubmission,

        /**
         * Flushes all events currently cashed and sends them to the Reliability server.
         * @param {object} args
         *   @param {boolean} args.async: flag whether the HTTP request should be executed asynchronously
         */
        flush: sendEvents
      },
      utils: {
        /** Runs the given function and times the duration of its execution. If a threshold is provided, an event will be sent if the threshold is exceeded. If
         * no threshold is provided or the value is 0, the event will always be sent.
         * @param {object} args
         *  @param {function} args.func: function to be executed and timed
         *  @param {object} args.eventArgs: event data including the threshold property
         */
        timeExecution: timeExecution,

        /** Starts the timer for an asynchronous execution returning the timer object, which will record the duration once the done() method is invoked.
         * If a threshold is provided, an event will be sent if the threshold is exceeded. If no threshold is provided or the value is 0, the event will always be sent.
         * @param {object} args: event data including the threshold property
         */
        startTrackExecutionTimer: startTrackExecutionTimer
      }
    };
  }();

  ReliabilitySDK.Timer = function (args) {
    var _timeoutId = null;

    var _delay = args.delay;
    var _func = args.func;

    function dispose() {
      if (_timeoutId !== null) {
        clearTimeout(_timeoutId);
        _timeoutId = null;
      }
    }

    function init() {
      _timeoutId = setTimeout(function () {
        _timeoutId = null;

        _func();
      }, _delay);

      return {
        dispose: dispose
      };
    }

    return init();
  };

  ReliabilitySDK.enums = {
    SMART_METRIC_CATEGORIES: { //see com.smarttech.site.reliability.metrics.smart.SmartMetricCategories
      CONTROLLER: "controllers",
      THIRD_PARTY_CALLS: "thirdparty",
      ASYNC_TASKS: "tasks",
      PLATFORM_CALLS: "platform",
      INTERNAL_CALLS: "internalIntegration"
    },
    SMART_METRIC_TYPE: { // see com.smarttech.site.reliability.metrics.smart.SmartMetricTypes
      TIMER: "duration",
      OCCURRENCE_COUNTER: "occurrence",
      FAILURE_COUNTER: "failure",
      NOT_SPECIFIED: "ns"
    }
  };

  // Export for module
  if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = ReliabilitySDK;
  }

  return ReliabilitySDK;
})
